import $ from "jquery"; /* eslint-disable-line no-unused-vars */
import "@module@/icheck/icheck.js";

$(function() {
  $('input').iCheck({
    radioClass:    'iradio_flat-red mr-1',
    checkboxClass: 'icheckbox_flat-red mr-1',
    increaseArea:  '20%'
  });

  $('.it-modal-document').on("show.bs.modal", function(event) {
    const $modal   = $(event.target).closest(".modal");
    const $title   = $(".modal-title", $modal);
    const $content = $(".modal-body", $modal);

    /* Avoid loading the document repeatedly */
    if ($modal.hasClass("it-document-loaded"))
      return true;

    const documentId = parseInt($modal.data("document-id"), 10);
    if (!Number.isInteger(documentId) || documentId <= 0)
      return false;

    $content.text("Das Dokument wird geladen...");

    new Promise((resolve, reject) => {
      $.ajax({
        url: `/dokumente/${documentId}.json`,
        dataType: "json",
        cache: true,
      }).fail((jqXHR, textStatus, errorThrown) => {
        return reject(errorThrown || textStatus);
      }).done((json, textStatus, jqXHR) => {
        return resolve(json);
      });
    }).then(function(document) {
      $title.text(document.title || $title.text());
      $content.html(document.content || '');
      $modal.addClass("it-document-loaded");
    }).catch(function(error) {
      const errorMessage = error.message || error;
      $content.text(`Das Dokument konnte nicht geladen werden: ${errorMessage}`);
    });
  });

  $(window).on("hashchange", function() {
    if (window.location.hash.length > 1) {
      let $modal = $(window.location.hash);
      if ($modal.length) {
        $modal.modal("show");
        window.location.hash = "";
      }
    }
  });
});



// WEBPACK FOOTER //
// ./assets/scripts/common/base.js